import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { setDataValue, getDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';

const floatToBooleanDef = {
  type: FgBlockType.FloatToBoolean,
  build: () => ({
    dataIn: [sockIn("a", FgType.Number, 0)],
    dataOut: [sockOut("value", FgType.Boolean)]
  }),
  updateOutputs(block, ctx, env) {
    setDataValue(ctx, block, "value", !!getDataValue(ctx, env, block, "a"));
  }
};

export { floatToBooleanDef };
//# sourceMappingURL=float-to-boolean.js.map
